import React from 'react';

type HeaderItemProps = { children: React.ReactNode };

const HeaderItem = ({ children }: HeaderItemProps) => {
	return (
		<>
			<div className="pr0 flex" style={{ width: 'auto' }}>
				{children}
			</div>
			{/* <div className="pr0 flex-grow-1 flex" style={{ width: "auto" }}></div> */}
		</>
	);
};

export default HeaderItem;
